<template>
  <div>
    <PageTitle title="Home"/>
    <v-container class="pa-10">
      <v-alert
        v-if="notification"
        border="right"
        colored-border
        type="error"
        elevation="2"
        icon="mdi-alert-circle-outline"
      >
        {{ notification }}
      </v-alert>
      <UpcomingEventsTable role="speaker"/>
      <BlogPostsList/>
    </v-container>
  </div>
</template>

<script>
import PageTitle from '~src/components/common/pageTitle/pageTitle'
import BlogPostsList from '../common/dashboardBlogPostsList/BlogPostsList'
import UpcomingEventsTable from '../common/upkomingEventsTable/UpcomingEventsTable'

export default {
  name: 'SpeakerHome',
  props: {},
  components: {
    PageTitle,
    UpcomingEventsTable,
    BlogPostsList
  },
  data: () => ({
    // should come from BE
    // not sure what type of notification is it
    notification: ''
  }),
  computed: {},
  methods: {}
}
</script>

<style lang="scss">
  // @import 'path/_variables';
</style>
